namespace TabAurous.ProductDevelopment {
    export interface StagesForm {
        StageName: Serenity.StringEditor;
        Narration: Serenity.StringEditor;
        AllowPrivateComment: Serenity.BooleanEditor;
        AllowPublicComment: Serenity.BooleanEditor;
        SendEmail: Serenity.BooleanEditor;
        Members: StageMembersEditor;
    }

    export class StagesForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.Stages';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StagesForm.init)  {
                StagesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = StageMembersEditor;

                Q.initFormType(StagesForm, [
                    'StageName', w0,
                    'Narration', w0,
                    'AllowPrivateComment', w1,
                    'AllowPublicComment', w1,
                    'SendEmail', w1,
                    'Members', w2
                ]);
            }
        }
    }
}
